import {Form} from '../../../stores/Form';

export const getFormPathArray = (form: Form): string[] => {
    const pathArray = [];
    let currentForm = form;
    while (currentForm) {
        pathArray.push(currentForm.ename);
        currentForm = currentForm.parentForm;
    }
    return pathArray.reverse();
};
